


















































































































































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import OrganizationSearch from '@/components/organization-search/index.vue';
import { cloneDeep } from 'lodash';
import { trim, phone } from '@/utils/validators';
import { addOrEditUser, getPositionList, querySdUserInfo } from '@/api/system-management/index';
import ModalConfig from '@/components/modal-config/index.vue';
import { isShiDaill } from '@/utils/env';
export interface IForm {
  userName: string; // 账号
  password: string; // 密码
  realName: string; // 真实姓名
  phone: string; // 手机号码
  orgDepId: string; // 机构id
  positionIdList: string[]; // 岗位ID
  parkIdList: string[]; // 车场ID
  status: string;
  employeeId: string; //员工工号
}

@Component({
  components: {
    ParkingLotSearch,
    OrganizationSearch,
    ModalConfig
  }
})
export default class AddEditModal extends Vue {
  //判断是否是时代邻里
  isshidaill: boolean = isShiDaill;
  // 编辑状态回填数据
  @Prop()
  data!: any;

  // 是否编辑状态
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  // 校验字段方法
  validatorsTrim = trim;
  validatorsPhone = phone;
  form: any = null;

  positionOptions: any[] = [];
  orgDepId: string = '';

  confirmLoading: boolean = false;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };

  isUserName: boolean = false; // 判断登录账号是否有值

  thirdUserId: string = ''; // 第三方用户id

  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  // 登录账号值改变
  userNameChanged(e: any) {
    this.isUserName = !e.target.value;
  }

  get styles() {
    let w = '';
    w = this.isshidaill ? '75%' : '100%';
    return {
      width: w
    };
  }

  get isSelectAll() {
    return !this.isEdit && this.orgDepId !== '';
  }

  mounted() {
    this.init();
  }

  init() {
    this.confirmLoading = false;
    if (this.isEdit) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const {
            userName,
            realName,
            password,
            phone,
            orgDepId,
            positionIdList,
            status,
            parkIdList,
            employeeId
          } = this.data;
          this.orgDepId = orgDepId;
          this.onChangeOrgDepId(orgDepId);
          return {
            employeeId: this.$form.createFormField({
              value: employeeId
            }),
            userName: this.$form.createFormField({
              value: userName
            }),
            realName: this.$form.createFormField({
              value: realName
            }),
            password: this.$form.createFormField({
              value: password
            }),
            phone: this.$form.createFormField({
              value: phone
            }),
            orgDepId: this.$form.createFormField({
              value: orgDepId
            }),
            positionIdList: this.$form.createFormField({
              value: positionIdList
            }),
            status: this.$form.createFormField({
              value: status === '0' ? true : false
            }),
            parkIdList: this.$form.createFormField({
              value: parkIdList
            })
          };
        }
      });
    } else {
      this.orgDepId = '';
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            status: this.$form.createFormField({
              value: true
            }),
            parkIdList: this.$form.createFormField({
              value: []
            })
          };
        }
      });
    }
  }

  async onChangeOrgDepId(key: string) {
    if (!key) return;

    this.orgDepId = key;

    this.form.setFieldsValue({
      positionIdList: [],
      parkIdList: []
    });

    try {
      const { status, code, msg, data = [] } = await getPositionList({
        orgDepId: key
      });
      this.positionOptions = data;
    } catch (error) {
      this.$message.error('获取岗位失败');
    }
  }

  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.onAddOrEdit(values);
      }
    });
  }
  async onAddOrEdit(values: IForm) {
    if (this.confirmLoading) return false;
    this.confirmLoading = true;
    try {
      let { userName, realName, password, phone, orgDepId, positionIdList, parkIdList, status, employeeId } = values;
      let params = {};
      params = {
        userId: (this.isEdit && this.data && this.data.userId) || '',
        ...(this.isEdit ? {} : { password }),
        userName,
        realName,
        phone,
        orgDepId,
        positionIdList: typeof positionIdList === 'string' ? [positionIdList] : positionIdList,
        parkIdList,
        status: status ? '0' : '1',
        employeeId
      };
      if (this.isshidaill) {
        params = {
          userId: (this.isEdit && this.data && this.data.userId) || '',
          ...(this.isEdit ? {} : { password }),
          userName,
          realName,
          phone,
          orgDepId,
          positionIdList: typeof positionIdList === 'string' ? [positionIdList] : positionIdList,
          parkIdList,
          status: status ? '0' : '1',
          employeeId,
          thirdUserId: this.thirdUserId
        };
      }
      let result = await addOrEditUser(params);
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      this.form.resetFields();
      this.$emit('create');
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
    } finally {
      this.confirmLoading = false;
    }
  }
  /**
   * 查询用户信息
   */
  async getUserInfo() {
    try {
      let userName = this.form.getFieldValue('userName');
      const result = await querySdUserInfo({
        username: userName
      });
      this.thirdUserId = result.data.userId;
      const orgDepId = result.data.employeeOrganizationVOS[0].companyId;
      this.form.setFieldsValue({
        realName: result.data.empName,
        phone: result.data.mobilePhone,
        employeeId: result.data.code,
        orgDepId
      });
      this.onChangeOrgDepId(orgDepId);
    } catch (e) {
      this.$message.error((e && e.msg) || '查询用户信息失败');
    }
  }
}
